var map = {
	"./Afghanistan.gif": "5a8c",
	"./Albania.gif": "efd9",
	"./Algeria.gif": "c239",
	"./Angola.gif": "19f6",
	"./Antigua and Barbuda.gif": "81e9",
	"./Argentina.gif": "cc946",
	"./Armenia.gif": "213e",
	"./Austria.gif": "c942",
	"./Azerbaijan.gif": "f637",
	"./Bahrain.gif": "0852",
	"./Bangladesh.gif": "d9f7",
	"./Barbados.gif": "ca49",
	"./Belarus.gif": "acbe",
	"./Benin.gif": "26ea",
	"./Bhutan.gif": "2295",
	"./Bolivia.gif": "9f23",
	"./Bosnia and Herzegovina.gif": "1ac7",
	"./Botswana.gif": "2d21",
	"./Brazil.gif": "c9d0",
	"./Brunei Darussalam.gif": "4fb1",
	"./Bulgaria.gif": "b1c0",
	"./Burkina Faso.gif": "a0e9",
	"./Burkina-Faso.gif": "4bed",
	"./Burundi.gif": "3c08",
	"./Cabo Verde.gif": "4c9f",
	"./Cambodia.gif": "d853",
	"./Cameroon.gif": "40f6",
	"./Central African Republic.gif": "0fe0",
	"./Central-African-Republic.gif": "ba47",
	"./Chad.gif": "f360",
	"./Chile.gif": "8b21",
	"./Colombia.gif": "dc3f",
	"./Comoros.gif": "a88e",
	"./Congo.gif": "3a32",
	"./Cook Islands.gif": "543a",
	"./Cook-Islands.gif": "27ae",
	"./Costa Rica.gif": "a977",
	"./Cote d’Ivoire.gif": "7ec6",
	"./Croatia.gif": "97b0",
	"./Cuba.gif": "4635",
	"./Cyprus.gif": "2998",
	"./Czech Republic.gif": "9de2",
	"./Democratic Republic of Congo.gif": "87b9",
	"./Djibouti.gif": "246c",
	"./Dominica.gif": "2c63",
	"./Ecuador.gif": "732f",
	"./Egypt, Arab Rep..gif": "111c",
	"./El Salvador.gif": "3685",
	"./El-Salvador.gif": "3026",
	"./Equatorial Guinea.gif": "4d2a",
	"./Eritrea.gif": "bd61",
	"./Estonia.gif": "5658",
	"./Ethiopia.gif": "d933",
	"./Federated States of Micronesia.gif": "7565",
	"./Fiji.gif": "c760",
	"./Gabon.gif": "ae1b",
	"./Gambia.gif": "c356",
	"./Georgia.gif": "13ca",
	"./Ghana.gif": "cc8a",
	"./Greece.gif": "b7a9",
	"./Grenada.gif": "5002",
	"./Guinea-Bissau.gif": "77c7",
	"./Guinea.gif": "a826",
	"./Guyana.gif": "0ace",
	"./Hungary.gif": "0ccb",
	"./India.gif": "73a0",
	"./Indonesia.gif": "fc84",
	"./Iran, Islamic Rep..gif": "1787",
	"./Iraq.gif": "ecda",
	"./Israel.gif": "f62e",
	"./Italy.gif": "b1d9",
	"./Jamaica.gif": "24f4",
	"./Jordan.gif": "bbd4",
	"./Kazakhstan.gif": "6bbe",
	"./Kenya.gif": "601c",
	"./Kiribati.gif": "1e50",
	"./Korea.gif": "19ae",
	"./Kuwait.gif": "f4c0",
	"./Kyrgyz Republic.gif": "ae73",
	"./Lao PDR.gif": "2194",
	"./Latvia.gif": "06d5",
	"./Lebanon.gif": "4ffa",
	"./Lesotho.gif": "9cd7",
	"./Liberia.gif": "80af",
	"./Libya.gif": "4533",
	"./Lithuania.gif": "ba7c",
	"./Luxembourg.gif": "76d9",
	"./Macedonia, FYR.gif": "6714",
	"./Madagascar.gif": "b6227",
	"./Malaysia.gif": "4dc2",
	"./Maldives.gif": "2745",
	"./Mali.gif": "3db4",
	"./Malta.gif": "33a9",
	"./Mauritania.gif": "cee1a",
	"./Micronesia.gif": "231e",
	"./Moldova.gif": "6370",
	"./Mongolia.gif": "d56e",
	"./Montenegro.gif": "f160",
	"./Morocco.gif": "1911",
	"./Mozambique.gif": "fb8f",
	"./Myanmar.gif": "ab11",
	"./Namibia.gif": "7b64",
	"./Nepal.gif": "954d",
	"./New Zealand.gif": "bd63",
	"./Nicaragua.gif": "badb",
	"./Niger.gif": "a13c",
	"./Nigeria.gif": "f2c1",
	"./Niue.gif": "f620",
	"./Oman.gif": "c0fb",
	"./Pakistan.gif": "6a89",
	"./Palestine.gif": "cd8b",
	"./Panama.gif": "cf18a",
	"./Papua New Guinea.gif": "da47",
	"./Peru.gif": "506a",
	"./Philippines.gif": "87e9",
	"./Poland.gif": "cdeb",
	"./Portugal.gif": "ff38",
	"./Qatar.gif": "7a05",
	"./Romania.gif": "cfb4",
	"./Russian Federation.gif": "52e9",
	"./Rwanda.gif": "50fc",
	"./Samoa.gif": "48cf",
	"./Sao Tome and Principe.gif": "31d1",
	"./Sao-Tome-and-Principe.gif": "eba0",
	"./Saudi Arabia .gif": "07ca",
	"./Senegal.gif": "32d0",
	"./Serbia.gif": "7ed5",
	"./Seychelles.gif": "b718",
	"./Sierra Leone.gif": "77e3",
	"./Singapore.gif": "24ca",
	"./Slovak Republic.gif": "8328",
	"./Slovenia.gif": "2467",
	"./Solomon Islands.gif": "d3c1",
	"./Solomon-Islands.gif": "d192",
	"./Somalia.gif": "33fb",
	"./South Africa.gif": "0967",
	"./South Sudan.gif": "b0d5",
	"./South Korea.gif": "3f5d",
	"./Sri Lanka.gif": "8a39",
	"./Sudan.gif": "557f",
	"./Suriname.gif": "4856",
	"./Syria.gif": "2658",
	"./Syrian Arab Republic.gif": "ac2c",
	"./Tajikistan.gif": "b870",
	"./Tanzania.gif": "3bd1",
	"./Thailand.gif": "dea3",
	"./The Democratic Republic of the Congo.gif": "2bd0",
	"./The Dominican Republic.gif": "d230",
	"./The Republic of North Macedonia.gif": "2474",
	"./The-Democratic-Republic-of-the-Congo.gif": "5533",
	"./Timor-Leste.gif": "f295",
	"./Togo.gif": "f2df",
	"./Tonga.gif": "133d6",
	"./Trinidad and Tobago.gif": "5df2",
	"./Tunisia.gif": "b791",
	"./Turkey.gif": "da12",
	"./Turkmenistan.gif": "bb69",
	"./Uganda.gif": "1bd3",
	"./Ukraine.gif": "e066",
	"./Union-des-Comores.gif": "8364",
	"./United Arab Emirates.gif": "353a",
	"./Uruguay.gif": "eca9",
	"./Uzbekistan.gif": "8c42",
	"./Vanuatu.gif": "4b27",
	"./Venezuela, RB.gif": "e911",
	"./Vietnam.gif": "0903",
	"./Yemen, Rep..gif": "7507",
	"./Zambia.gif": "9aac",
	"./Zimbabwe.gif": "c86c",
	"./default.gif": "5d2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63a8";